import { Suspense, lazy } from "react";
import { motion } from "framer-motion";

const ParticleField = lazy(() => import("./ParticleField"));

export default function FXBackdrop({ children }) {
  return (
    <div className="relative overflow-hidden min-h-screen">
      {/* 3D particle field — fixed behind everything */}
      <Suspense fallback={null}>
        <ParticleField />
      </Suspense>

      {/* aurora blobs — purple tones */}
      <motion.div
        className="pointer-events-none absolute -top-40 -left-40 h-[520px] w-[520px] rounded-full"
        style={{ background: "radial-gradient(circle, rgba(139,92,246,0.18), transparent 60%)", filter: "blur(12px)" }}
        animate={{ x: [0, 40, 0], y: [0, 25, 0] }}
        transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="pointer-events-none absolute -bottom-40 -right-40 h-[560px] w-[560px] rounded-full"
        style={{ background: "radial-gradient(circle, rgba(168,85,247,0.15), transparent 60%)", filter: "blur(12px)" }}
        animate={{ x: [0, -40, 0], y: [0, -20, 0] }}
        transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[620px] w-[620px] rounded-full"
        style={{ background: "radial-gradient(circle, rgba(124,58,237,0.08), transparent 60%)", filter: "blur(14px)" }}
        animate={{ scale: [1, 1.05, 1] }}
        transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
      />

      {/* checkered grid lines */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage:
            "linear-gradient(rgba(139,92,246,0.18) 1px, transparent 1px), linear-gradient(90deg, rgba(139,92,246,0.18) 1px, transparent 1px)",
          backgroundSize: "48px 48px",
          opacity: 0.7,
        }}
      />

      <div className="relative">{children}</div>
    </div>
  );
}
